module.exports = __webpack_public_path__ + "img/green-flower.fda87afb.png";